var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2424 23.8334H27.071M16.2424 31.1667H21.6567M7.21851 7.33341V36.6667C7.21851 37.6392 7.5988 38.5718 8.27572 39.2595C8.95264 39.9471 9.87075 40.3334 10.8281 40.3334H32.4854C33.4427 40.3334 34.3608 39.9471 35.0377 39.2595C35.7146 38.5718 36.0949 37.6392 36.0949 36.6667V15.2937C36.0949 14.8053 35.9987 14.3217 35.8122 13.8715C35.6256 13.4213 35.3523 13.0135 35.0085 12.6721L26.9952 4.71175C26.3209 4.04195 25.4153 3.66687 24.4722 3.66675H10.8281C9.87075 3.66675 8.95264 4.05306 8.27572 4.74069C7.5988 5.42832 7.21851 6.36095 7.21851 7.33341V7.33341Z",
    stroke: "#757575",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2664 3.66675V11.0001C25.2664 11.9725 25.6466 12.9052 26.3236 13.5928C27.0005 14.2804 27.9186 14.6667 28.8759 14.6667H36.095",
    stroke: "#757575",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.b3246b6cab5f37fed86394f43739f6e9.svg";
export { ForwardRef as ReactComponent };